import { RegistrationGroupHelper } from '..';

export const useRegistrationGroup = () => {
	let registrationGroupHelper = new RegistrationGroupHelper();
	return {
		registrationGroupHelper,
		activeRegistrationGroup: registrationGroupHelper.active()
	};
};
